module.exports = __webpack_public_path__ + "static/media/upload.d73e6d5a.svg";